import { useState, useEffect } from 'react'
import { settingsAPI } from '@utils/api'

const FALLBACK_LOGO    = '/deoriginlabs-logo.png'
const FALLBACK_FAVICON = '/favicon.ico'
// Module-level singleton — shared across all hook instances
const state = { logo: FALLBACK_LOGO, adminLogo: FALLBACK_LOGO, favicon: FALLBACK_FAVICON }
let _promise  = null
const _subs   = new Set()

const notify = () => _subs.forEach(fn => fn())

const applyFavicon = (url) => {
  try {
    document.querySelectorAll("link[rel*='icon']").forEach(el => el.remove())
    const link = document.createElement('link')
    link.rel   = 'icon'
    link.href  = url
    document.head.appendChild(link)
  } catch {}
}

export const updateBranding = ({ type, url }) => {
  if (type === 'logo')       state.logo      = url
  if (type === 'admin-logo') state.adminLogo = url
  if (type === 'favicon')  { state.favicon   = url; applyFavicon(url) }
  notify()
}

const loadBranding = () => {
  if (_promise) return _promise
  _promise = settingsAPI.getPublic()
    .then(res => {
      const d = res?.data
      const t = `?t=${Date.now()}`
      if (d?.logoUrl)      state.logo      = `${d.logoUrl}${t}`
      if (d?.adminLogoUrl) state.adminLogo = `${d.adminLogoUrl}${t}`
      if (d?.faviconUrl) { state.favicon   = `${d.faviconUrl}${t}`; applyFavicon(state.favicon) }
      notify()
    })
    .catch(() => { _promise = null })
  return _promise
}

export const useLogo = () => {
  const [logo,       setLogo]       = useState(() => state.logo)
  const [adminLogo,  setAdminLogo]  = useState(() => state.adminLogo)
  const [favicon,    setFavicon]    = useState(() => state.favicon)

  useEffect(() => {
    setLogo(state.logo)
    setAdminLogo(state.adminLogo)
    setFavicon(state.favicon)

    const sub = () => {
      setLogo(state.logo)
      setAdminLogo(state.adminLogo)
      setFavicon(state.favicon)
    }
    _subs.add(sub)
    loadBranding()
    return () => _subs.delete(sub)
  }, [])

  return { logo, adminLogo, favicon }
}
